import api from "./api.service";
import { adminTokenService, AdminData } from "./admin.token.service";
import axios from "axios";

// Response type for the admin auth service
export interface AdminAuthResponse {
  adminData: AdminData | null;
  error: string | null;
  success: boolean;
}

// const apiURL = getApiBaseUrl(); // Removed to use api service baseURL

class AdminAuthService {
  // Login admin with email and password
  async loginAdminWithEmail(email: string, password: string): Promise<AdminAuthResponse> {
    try {
      const payload = { email, password };
      const response = await api.post(`/admin-login`, payload);

      const token = response.data.token;
      if (token) {
        // Store the token
        adminTokenService.setAdminToken(token);

        // Decode token to get admin data
        const decodedToken = adminTokenService.getAdminDataToken();
        if (decodedToken && decodedToken.adminData) {
          return {
            adminData: decodedToken.adminData,
            error: null,
            success: true,
          };
        }
      }

      // Handle cases where token is not received or is invalid
      return {
        adminData: null,
        error: "Token no válido o no recibido.",
        success: false,
      };

    } catch (error) {
      let errorMessage = "Ha ocurrido un error inesperado";
      if (axios.isAxiosError(error)) {
        errorMessage = error.response?.data?.message || "Credenciales incorrectas";
        console.error("Error de Axios al llamar a admin-login:", errorMessage);
      } else {
        console.error("Error inesperado al llamar a admin-login:", error);
      }
      return {
        adminData: null,
        error: errorMessage,
        success: false,
      };
    }
  }

  // Logout for admin
  async logoutAdmin(): Promise<void> {
    try {
      adminTokenService.removeAdminToken();
      console.log("Sesión de administrador cerrada y token eliminado.");
    } catch (error) {
      console.error("Error al cerrar sesión de administrador:", error);
    }
  }
}

export const adminAuthService = new AdminAuthService();
